import { TimePicker as MantineTimePicker } from "@mantine/dates";
import { componentWrapper } from "../../utilities";
import styles from "./time-picker.module.scss";
import type { CustomTimePickerFactory, IProps } from "./time-picker.types";

const TimePicker = componentWrapper<CustomTimePickerFactory, IProps>("TimePicker", (props, ref) => {
    return <MantineTimePicker ref={ref} classNames={{ root: styles["root"] }} {...props} />;
});

export { TimePicker };
